import React from 'react';
import { IncrementIconProps } from './IncrementIcon';

const DecrementIcon = ({ invertColor }: IncrementIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
      <mask id="mask0_7408_85330" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="16">
        <rect width="12" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7408_85330)">
        <path
          d="M5.1665 9.83268V2.99935C5.1665 2.76324 5.24637 2.56532 5.40609 2.4056C5.56581 2.24588 5.76373 2.16602 5.99984 2.16602C6.23595 2.16602 6.43386 2.24588 6.59359 2.4056C6.75331 2.56532 6.83317 2.76324 6.83317 2.99935V9.83268L9.24984 7.41602C9.40262 7.26324 9.59706 7.18685 9.83317 7.18685C10.0693 7.18685 10.2637 7.26324 10.4165 7.41602C10.5693 7.56879 10.6457 7.76324 10.6457 7.99935C10.6457 8.23546 10.5693 8.4299 10.4165 8.58268L6.58317 12.416C6.4165 12.5827 6.22206 12.666 5.99984 12.666C5.77762 12.666 5.58317 12.5827 5.4165 12.416L1.58317 8.58268C1.43039 8.4299 1.354 8.23546 1.354 7.99935C1.354 7.76324 1.43039 7.56879 1.58317 7.41602C1.73595 7.26324 1.93039 7.18685 2.1665 7.18685C2.40261 7.18685 2.59706 7.26324 2.74984 7.41602L5.1665 9.83268Z"
          fill={invertColor ? 'var(--green-base)' : 'var(--red-base)'}
        />
      </g>
    </svg>
  );
};

export default DecrementIcon;
